import React, { Component } from 'react';
import Webcam from "react-webcam";
import "./PvWebcam.css";

class PvWebcam extends Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.pv_uuid = urlParams.get('pv_uuid');
        this.recordedChunks = [];
        console.log(this.props.PvApiUrl);
        console.log(this.pv_uuid);


        this.videoElement = React.createRef();

        this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                console.log('entry', entry)
                this.props.handleVideoWidthChange(entry.contentRect.width)
                this.props.handleVideoHeightChange(entry.contentRect.height)
            }
        });
        this.state = {
            mimeType: "video/webm"
        }
    }


    handleDataAvailable = ({ data }) => {
        console.log('handleDataAvailable ++++++++++++++++++++++++++')
        console.log(data);
        console.log(this.props.mediaRecorder);
        console.log('handleDataAvailable --------------------------')
        if (data.size > 0) {
            this.recordedChunks.push(data);
        }
        if (this.props.mediaRecorder.state === "inactive") {
            this.handleSend();
        }
    }

    handleSend = () => {
        this.props.setDisplayLoadingScreenState();
        if (this.recordedChunks.length) {
            const blob = new Blob(this.recordedChunks, {
                type: this.state.mimeType
            });
            const body = new FormData()
            body.append("video_file", blob)
            const urlBase = `${this.props.PvApiUrl}/pv_session/${this.pv_uuid}/vid`
            let url;
            if (this.state.mimeType === "video/webm") {
                url = `${urlBase}/webm`
            } else if (this.state.mimeType === 'video/mp4') {
                url = `${urlBase}/mp4`
            } else {
                console.log("welcome traveler!")
            }
            console.log(url)
            console.log("wysyłam POST do API...")
            fetch(url, {
                body,
                headers: {
                    Accept: "application/json",
                },
                method: "POST"
            }).then((response) => {
                console.log("jest response z API")
                console.log(response)
                if (response.status === 200) {
                    this.props.handleDisplayExitScreen();
                } else {
                    this.props.handleServerError(response.status, response.statusText);
                }
            }).catch((error) => {
                console.log("wyjebało")
                console.log(error)
            }).finally(() => {
                this.recordedChunks = [];
            })
        }
    }

    


    handleUserMedia = (stream) => {
        this.props.setStream(stream);
        let mediaRecorder;
        try {
            mediaRecorder = new MediaRecorder(stream, {
                mimeType: "video/webm"
            });
        }
        catch (err1) {
            try {

                mediaRecorder = new MediaRecorder(stream, {
                    mimeType: "video/mp4"
                });
                this.setState({ mimeType: "video/mp4" })
            }
            catch (err2) {
                // If fallback doesn't work either. Log / process errors.
                console.error({ err1 });
                console.error({ err2 })
            }
        }
        mediaRecorder.addEventListener(
            "dataavailable",
            this.handleDataAvailable
        );
        mediaRecorder.start();
        this.props.setMediaRecorder(mediaRecorder);
        this.props.handleRecordingStarted();
    }

    componentDidMount = () => {
        // console.log(this.videoElement.current.video)
        console.log('dupa')
        this.resizeObserver.observe(this.videoElement.current.video)

        const url = `${this.props.PvApiUrl}/pv_session/${this.pv_uuid}/status`
        console.log(url)
        console.log("wysyłam POST do API z buttonClick...")
        fetch(url, {
            method: 'POST'
        }).then((response) => {
            console.log("odpowiedz od API")
            console.log(response)
        }).catch((error) => {
            console.log('warning')
            console.log(error)
        })
    }



    render() {
        return (
            <Webcam
                mirrored
                onUserMedia={this.handleUserMedia}
                onUserMediaError={this.props.handleUserMediaError}
                className="PvWebcam"
                audio={true}
                muted={true}
                ref={this.videoElement}
            />
        );
    }
};


export default PvWebcam;